const pt = {
  common: {
    acontecer: '(ACONTECER)',
    falamos: 'FALAMOS?',
    quemSomos: 'QUEM SOMOS?',
    workWithUs: 'WORK WITH US',
    vagas: 'VAGAS',
    back: 'VOLTAR',
    instagram: 'INSTAGRAM',
    linkedin: 'LINKEDIN',
    copyright: 'FAZ ALL RIGHTS RESERVED'
  },
  sound: {
    on: 'ON',
    off: 'OFF'
  },
  navigation: {
    home: 'Home',
    about: 'Sobre',
    contact: 'Contato'
  },
  footer: {
    title: 'VAMOS <span class="italic font-cormorant">fazer</span> ACONTECER?',
    subtitle: 'Vamos fazer acontecer?'
  },
  home: {
    hero: {
      title: 'SOMOS CRAFT : FAZEMOS ACONTECER.',
      subtitle: 'Somos uma agência boutique criativa, com visão internacional e craft no detalhe.',
      description: [
        'Somos uma agência boutique criativa, com visão internacional e craft no detalhe.',
        'Acreditamos que a excelência constrói confiança, resiste ao tempo e transforma marcas em ícones.',
        'Juntamos grandes ideias a uma execução precisa.',
        'Ouvimos com atenção, construímos com intenção e entregamos com rigor.',
        'Trabalhamos em união e elevamos a cultura.',
        'Mais do que uma agência — somos parceiros de criação.'
      ]
    },
    services: {
      title: 'O QUE FAZEMOS',
      items: {
        branding: {
          title: 'BRANDING E REBRANDING',
          description: 'Criamos e revitalizamos marcas com estratégia, clareza e identidade. Do naming à identidade visual, passando pela voz e pelo posicionamento, construímos marcas com carácter e propósito.'
        },
        identidade: {
          title: 'IDENTIDADE E COMUNICAÇÃO DE MARCA',
          description: 'Definimos e alinhamos posicionamento, arquétipo, tom de voz e cultura. Comunicamos com coerência, personalidade e intenção — dentro e fora do digital.'
        },
        campanhas: {
          title: 'DIREÇÃO CRIATIVA E CAMPANHAS',
          description: 'Desenvolvemos campanhas, online e offline, com conceitos fortes, execução cuidada e impacto real. Da ideia à produção, entregamos com craft e consistência.'
        },
        conteudo: {
          title: 'CONTEÚDO DE MARCA',
          description: 'Criamos narrativas visuais e verbais com foco em lifestyle, emoção e aspiração. Produzimos conteúdo que traduz essência, ambição e estética.'
        },
        digital: {
          title: 'EXPERIÊNCIA DIGITAL PREMIUM',
          subtitle: '(WEB E PRODUTO)',
          description: 'Desenhamos soluções digitais com foco em estratégia, UX/UI e estética contemporânea. Criamos websites, plataformas e produtos digitais com atenção ao detalhe e impacto visual.'
        },
        consultoria: {
          title: 'CONSULTORIA CRIATIVA E CULTURAL',
          description: 'Apoiamos marcas em transição ou crescimento com pensamento estratégico e sensibilidade cultural. Identificamos o caminho para a relevância, no presente e para o futuro.'
        }
      }
    },
    modoOperandi: {
      title: 'Modus Operandi',
      subtitle: 'COMO FAZEMOS',
      items: {
        envolvimento: {
          title: 'COM ENVOLVIMENTO',
          description: 'A nossa equipa é dedicada, com direção sénior e colaboração AI.'
        },
        proximidade: {
          title: 'COM PROXIMIDADE',
          description: 'Criamos relações diretas, sem rodeios.'
        },
        foco: {
          title: 'COM FOCO',
          description: 'Desenvolvemos com critério — aprofundamos.'
        },
        agilidade: {
          title: 'COM AGILIDADE',
          description: 'Alinhamos em sprints claros, somos de entregas flexíveis.'
        },
        parceria: {
          title: 'COM PARCERIA',
          description: 'Mais do que fornecedores, somos co-criadores.'
        },
        cultura: {
          title: 'COM CULTURA',
          description: 'Respeitamos identidade e elevamos narrativas.'
        }
      }
    }
  },
  about: {
    title: 'NÃO SOMOS DE RODEIOS.',
    subtitle: 'UM NOME SIMPLES, UMA MISSÃO CLARA, UM LEGADO DE FAZER.',
    description: [
      'Fazer com intenção; no detalhe, na estética e na coragem criativa.',
      'Na medida certa; proximidade no processo, impacto à escala global.',
      'A (FAZ) nasce da VX, um grupo com mais de 20 anos de experiência entre Brasil e Europa.',
      'Trazemos no ADN o legado de uma agência com campanhas reconhecidas internacionalmente',
      'e um olhar contemporâneo, sintonizado com cada contexto.',
      'Aliamos cultura a craft, com trajetos distintos e uma visão comum.'
    ]
  },
  contact: {
    form: {
      name: 'NOME',
      email: 'EMAIL',
      subject: 'ASSUNTO',
      message: 'MENSAGEM',
      submit: 'ENVIAR',
      sending: 'A ENVIAR...',
      sendAnother: 'Enviar outra mensagem',
      tryAgain: 'Tentar novamente',
      orSendMessage: 'OU ENVIAR MENSAGEM:',
      placeholders: {
        name: 'Introduzir nome completo',
        email: 'Introduzir e-mail',
        subject: 'Introduzir assunto da mensagem',
        message: 'Introduzir mensagem'
      }
    },
    messages: {
      success: {
        title: 'Mensagem enviada com sucesso!',
        subtitle: 'Entraremos em contacto em breve.'
      },
      error: {
        title: 'Erro ao enviar mensagem!',
        subtitle: 'Tente novamente em alguns instantes.'
      }
    },
    validation: {
      name: {
        required: 'Nome é obrigatório',
        minLength: 'Nome deve ter pelo menos 2 caracteres',
        maxLength: 'Nome deve ter no máximo 50 caracteres'
      },
      email: {
        required: 'E-mail é obrigatório',
        invalid: 'E-mail deve ter um formato válido'
      },
      subject: {
        required: 'Assunto é obrigatório',
        minLength: 'Assunto deve ter pelo menos 5 caracteres',
        maxLength: 'Assunto deve ter no máximo 100 caracteres'
      },
      message: {
        required: 'Mensagem é obrigatória',
        minLength: 'Mensagem deve ter pelo menos 10 caracteres',
        maxLength: 'Mensagem deve ter no máximo 1000 caracteres'
      },
      turnstile: {
        required: 'Por favor, complete a verificação de segurança',
        error: 'Erro na verificação de segurança. Tente novamente.',
        expired: 'Verificação de segurança expirada. Refaça a verificação.'
      }
    },
    phone: {
      title: 'LIGAR:',
      number: '+351 923 522 385'
    }
  },
  marquee: {
    light: {
      brand: 'WE ARE FAZ',
      tagline: 'Somos Faz'
    },
    dark: {
      entrega: 'ENTREGA',
      evolucao: 'EVOLUÇÃO',
      estrategia: 'ESTRATÉGIA',
      expressao: 'EXPRESSÃO'
    }
  },
  workWithUs: {
    title: 'VAGAS',
    subtitle: 'Junte-se à nossa equipa criativa e ajude-nos a fazer acontecer.',
    description: [
      'Procuramos talentos criativos que partilhem a nossa paixão pela excelência e pelo craft no detalhe.',
      'Oferecemos um ambiente de trabalho inspirador, com projetos internacionais e oportunidades de crescimento.',
      'Se tem sede de desafios e quer fazer parte de uma equipa que valoriza a criatividade e a inovação, venha trabalhar connosco.',
      'Envie o seu portfólio e CV para careers@wearefaz.com e vamos fazer acontecer juntos.'
    ],
    whyWorkWithUs: {
      title: 'PORQUE TRABALHAR CONOSCO?',
      items: [
        {
          title: 'LIBERDADE CRIATIVA',
          description: 'Acreditamos em dar à nossa equipa o espaço para explorar, experimentar e criar sem limites.'
        },
        {
          title: 'EXPOSIÇÃO INTERNACIONAL',
          description: 'Trabalhe em projetos que abrangem diferentes culturas e mercados, expandindo os seus horizontes criativos.'
        },
        {
          title: 'EXCELÊNCIA NO CRAFT',
          description: 'Faça parte de uma equipa que valoriza a atenção ao detalhe e entrega trabalho da mais alta qualidade.'
        },
        {
          title: 'OPORTUNIDADES DE CRESCIMENTO',
          description: 'Investimos no desenvolvimento da nossa equipa com aprendizagem contínua e oportunidades de progressão na carreira.'
        }
      ]
    },
    openPositions: {
      title: 'VAGAS ABERTAS',
      applyButton: 'Candidatar-se',
      items: [
        {
          title: 'DIRETOR CRIATIVO SÉNIOR',
          location: 'Lisboa / Remoto',
          type: 'Tempo integral',
          postedDate: 'Publicado há 2 dias',
          description: 'Liderar a direção criativa para marcas internacionais e orientar a nossa equipa criativa.',
          skills: ['Direção Criativa', 'Estratégia de Marca', 'Liderança de Equipa', 'Adobe Creative Suite']
        },
        {
          title: 'DESIGNER DIGITAL',
          location: 'Lisboa',
          type: 'Tempo integral',
          postedDate: 'Publicado há 1 semana',
          description: 'Criar experiências digitais e interfaces de utilizador impressionantes para os nossos clientes premium.',
          skills: ['Design UI/UX', 'Figma', 'Web Design', 'Prototipagem']
        },
        {
          title: 'COPYWRITER',
          location: 'Remoto',
          type: 'Part-time',
          postedDate: 'Publicado há 3 dias',
          description: 'Criar copy convincente que dá vida às marcas em todos os pontos de contacto.',
          skills: ['Copywriting', 'Voz da Marca', 'Estratégia de Conteúdo', 'Inglês/Português']
        }
      ]
    },
    howToApply: {
      title: 'COMO CANDIDATAR-SE',
      description: 'Pronto para se juntar à nossa equipa? Aqui está como começar:',
      steps: [
        'Envie o seu portfólio e CV para careers@wearefaz.com',
        'Inclua uma carta de apresentação explicando por que quer trabalhar connosco',
        'Vamos analisar a sua candidatura e responder-lhe em 5 dias úteis',
        'Se selecionado, agendaremos uma entrevista criativa para discutir o seu trabalho',
        'Junte-se à nossa equipa e comece a fazer acontecer!'
      ]
    }
  },
  workWithUsPage: {
    firstSection: {
      title: 'PESSOAS QUE FAZEM ACONTECER.',
      subtitle: 'Curiosidade. Criatividade. Coragem.',
      description: [
        'Para quem desafia ideias, cria com intenção e mexe com o status quo.',
        'Vê as nossas vagas e entra em contacto mesmo que não haja um encaixe perfeito.',
        'Talento em bruto não espera.'
      ],
      letsTalkButton: 'FALAR CONNOSCO'
    },
    jobs: {
      learnMoreButton: 'SABER MAIS',
      accountManager: {
        location: 'LISBOA',
        title: 'ACCOUNT MANAGER'
      },
      seniorDesigner: {
        location: 'LISBOA',
        title: 'SENIOR MULTIDISCIPLINARY DESIGNER'
      },
      personalAssistant: {
        location: 'LISBOA',
        title: 'PERSONAL ASSISTANT / CHIEF OF STAFF JÚNIOR'
      }
    },
    accountManager: {
      title: 'ACCOUNT MANAGER (FOUNDING TEAM)',
      location: 'LISBOA',
      introduction: [
        'A FAZ está à procura de um Account Manager organizado, proativo e com espírito de liderança.',
        'Serás o ponto de contacto principal entre os clientes e a equipa criativa, garantindo a excelência na gestão de contas, a entrega de projetos de alto nível e a construção de processos desde o início.'
      ],
      whatWeExpect: {
        title: 'O QUE ESPERAMOS DE UM ACCOUNT MANAGER',
        items: [
          'Liderar contas e relações com clientes de forma estratégica e prática.',
          'Transformar objetivos de negócio em roadmaps e KPIs acionáveis.',
          'Montar processos, templates e playbooks que façam a equipa funcionar com excelência.',
          'Comunicar de forma clara, elegante e eficiente com clientes e equipa.'
        ]
      },
      responsibilities: {
        title: 'RESPONSABILIDADES',
        items: [
          'Gerir o ciclo completo de contas: briefing → planeamento → execução → reporting.',
          'Coordenar equipas internas e externas (criatividade, conteúdo, paid, web).',
          'Garantir qualidade, cumprimento de prazos e controlo de orçamento.',
          'Preparar propostas, SOWs, cronogramas e atividades de pós-venda (upsell/cross-sell).',
          'Monitorizar métricas e transformar dados em decisões estratégicas.'
        ]
      },
      qualifications: {
        title: 'QUALIFICAÇÕES',
        items: [
          'Experiência em agência (account/project) com visão 360º de marketing.',
          'Inglês fluente.',
          'Perfil estratégico, com execução impecável e sentido de ownership.',
          'Conforto com ferramentas digitais: Google Workspace, Slack, Notion/Monday/Asana, HubSpot/CRM.',
          'Capacidade de transformar métricas de social, paid e web em insights acionáveis.'
        ]
      },
      whatWeOffer: {
        title: 'O QUE OFERECEMOS',
        items: [
          'Integração na Founding Team de uma agência boutique com ambição global.',
          'Autonomia real e contacto direto com a direção, com plano de progressão definido.',
          'Trabalho remoto em 2025 e escritório em Lisboa a partir de 2026.',
          'Cultura de craft, criatividade estratégica e foco em "fazer acontecer".',
          'Condições competitivas, ajustadas à experiência e evolução por desempenho.'
        ]
      },
      locationArrangement: {
        title: 'LOCAL & REGIME',
        items: [
          'Remoto (Portugal), com disponibilidade pontual para reuniões presenciais ou viagens.',
          'Horário compatível com clientes internacionais.'
        ]
      },
      first90Days: {
        title: 'PRIMEIROS 90 DIAS — O QUE ESPERAMOS VER',
        items: [
          'Onboarding concluído e processos base montados (rituais, templates, dashboards).',
          '2–3 contas a correr com NPS/CSAT alto, prazos controlados e relatórios mensais.',
          'Playbook de comunicação com clientes e matriz de responsabilidades definidos.'
        ]
      },
            howToApply: {
              title: 'COMO CANDIDATAR-TE',
              text: 'Envia CV (PDF) para',
              email: 'hello@wearefaz.com',
              subject: 'com o assunto: "Account Manager — FAZ".'
            },
      applyButton: 'CANDIDATAR-ME'
    },
    seniorDesigner: {
      title: 'SENIOR MULTIDISCIPLINARY DESIGNER',
      location: 'LISBOA',
      introduction: [
        'A FAZ está à procura de um Senior Multidisciplinary Designer criativo, estratégico e autónomo.',
        'Serás o ponto de contacto entre clientes e equipa criativa para o desenvolvimento de soluções visuais e digitais de alto nível, garantindo a excelência na execução dos projetos e a construção de processos desde o início.'
      ],
      whatWeExpect: {
        title: 'O QUE ESPERAMOS DE UM SENIOR MULTIDISCIPLINARY DESIGNER',
        items: [
          'Criar projetos de design multidisciplinares, com atenção ao detalhe e à consistência visual.',
          'Transformar objetivos de negócio em soluções visuais e experiências digitais impactantes (websites, apps, campanhas, conteúdos digitais).',
          'Aplicar sólidos princípios de design para criar conceitos claros, funcionais e esteticamente impactantes.',
          'Desenvolver processos, templates e guidelines que elevem o nível da equipa criativa.',
          'Comunicar de forma clara, elegante e eficiente com clientes e equipa.',
          'Experiência em motion e 3D valorizada.'
        ]
      },
      responsibilities: {
        title: 'RESPONSABILIDADES',
        items: [
          'Desenvolver conceitos e execuções visuais para branding, digital, packaging e conteúdos multimédia.',
          'Criar protótipos, wireframes e sistemas de design responsivos que traduzam a identidade da marca em experiências digitais consistentes.',
          'Colaborar com equipas internas e externas, assegurando qualidade e coesão criativa.',
          'Garantir cumprimento de prazos, orçamento e padrões de excelência visual.',
          'Apoiar e orientar designers juniores e mid-level, fornecendo feedback construtivo e promovendo elevados padrões de craft.',
          'Participar na elaboração de apresentações, propostas e workshops criativos.',
          'Monitorizar resultados e métricas de design e experiência, transformando insights em melhorias práticas.'
        ]
      },
      qualifications: {
        title: 'QUALIFICAÇÕES',
        items: [
          'Experiência sólida em design multidisciplinar, preferencialmente em agência ou estúdio criativo.',
          'Portfólio robusto que demonstre capacidade de resolução de problemas, inovação e storytelling visual.',
          'Conhecimentos de UX/UI e princípios de design aplicados a múltiplos suportes.',
          'Perfil estratégico, autónomo e com sentido de ownership.',
          'Confortável com ferramentas digitais de design, prototipagem e gestão de projetos (Adobe Creative Suite, Figma, Notion/Monday/Asana, etc.).',
          'Inglês fluente.',
          'Perfil colaborativo, proativo, atento aos detalhes e capaz de comunicar ideias de forma clara e inspirar confiança em clientes e equipa.'
        ]
      },
      whatWeOffer: {
        title: 'O QUE OFERECEMOS',
        items: [
          'Integração na Founding Team de uma agência boutique com ambição global.',
          'Autonomia real e contacto direto com a direção, com plano de progressão definido.',
          'Trabalho remoto em 2025 e escritório em Lisboa planeado para 2026.',
          'Cultura de craft, criatividade estratégica e foco em "fazer acontecer".',
          'Condições competitivas, ajustadas à experiência e evolução por desempenho.',
          'A FAZ valoriza a diversidade e acredita que um ambiente inclusivo fortalece a criatividade e a qualidade do trabalho.'
        ]
      },
      locationArrangement: {
        title: 'LOCAL & REGIME',
        items: [
          'Remoto (Portugal), com disponibilidade pontual para reuniões presenciais ou viagens.',
          'Horário compatível com clientes internacionais.'
        ]
      },
      first90Days: {
        title: 'PRIMEIROS 90 DIAS — O QUE ESPERAMOS VER',
        items: [
          'Onboarding concluído e processos de design base montados (templates, guidelines, dashboards).',
          '2–3 projetos ativos com qualidade elevada, prazos controlados e feedback positivo de clientes.',
          'Playbook de design e matriz de responsabilidades definidos.'
        ]
      },
      howToApply: {
        title: 'COMO CANDIDATAR-TE',
        text: 'Envia CV e portfólio (PDF) para',
        email: 'hello@wearefaz.com',
        subject: 'com o assunto: "Senior Multidisciplinary Designer - FAZ".'
      }
    },
    personalAssistant: {
      title: 'PERSONAL ASSISTANT / CHIEF OF STAFF JÚNIOR',
      fullTime: '(FULL-TIME)',
      location: 'LISBOA',
      introduction: [
        'Estamos à procura de um(a) Personal Assistant altamente organizado(a), proativo(a) e com espírito de resolução de problemas para integrar a nossa equipa.',
        'Esta função é híbrida entre assistente pessoal e profissional, funcionando como o braço direito dos CEO\'s, garantindo que tanto a vida pessoal como profissional fluem de forma eficiente e estruturada.'
      ],
      whatWeExpect: {
        title: 'O QUE ESPERAMOS DE UM/A PERSONAL ASSISTANT / CHIEF OF STAFF JÚNIOR',
        items: [
          'Apoiar diretamente os CEO\'s em tarefas pessoais e profissionais.',
          'Gerir agendas, marcação de reuniões, viagens e compromissos pessoais.',
          'Organizar prioridades, acompanhar projetos e garantir follow-ups ("next steps") das equipas.',
          'Preparar documentos, apresentações e pequenas pesquisas de mercado.',
          'Comunicar com a equipa interna e parceiros externos, facilitando a execução das tarefas.',
          'Apoiar nas tarefas do dia-a-dia, desde organização pessoal até pequenas gestões.',
          'Ser ponto de ligação entre os CEO\'s e os diferentes stakeholders, garantindo clareza e alinhamento.'
        ]
      },
      qualifications: {
        title: 'QUALIFICAÇÕES',
        items: [
          'Forte capacidade de organização, atenção ao detalhe e método.',
          'Proatividade, autonomia e capacidade de antecipar necessidades.',
          'Excelente comunicação oral e escrita em português e inglês.',
          'Capacidade de lidar com múltiplas tarefas e gerir prioridades simultaneamente.',
          'Descrição, confiança e postura profissional.',
          'Experiência prévia como Personal Assistant, Executive Assistant ou funções semelhantes (valorizado, mas não obrigatório).'
        ]
      },
      whatWeOffer: {
        title: 'O QUE OFERECEMOS',
        items: [
          'Integração numa equipa dinâmica e criativa.',
          'Oportunidade de crescimento e aprendizagem contínua, com exposição a diferentes áreas de negócio.',
          'Trabalho próximo da liderança, num papel estratégico e de confiança.'
        ]
      },
      locationArrangement: {
        title: 'LOCAL & REGIME',
        items: [
          'Híbrido (Lisboa), com flexibilidade para trabalho remoto e presencial conforme necessidade.'
        ]
      },
      howToApply: {
        title: 'COMO CANDIDATAR-TE',
        text: 'Envia CV para',
        email: 'hello@wearefaz.com',
        subject: 'com o assunto: "Personal Assistant / Chief of Staff Júnior — FAZ".'
      }
    }
  }
}

export default pt 